import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'firstLetterCapitalise',
  standalone: true,
})
export class FirstLetterCapitalisePipe implements PipeTransform {
  transform(value: string | undefined): string {
    if (!value) return '';

    return `${value.substring(0, 1).toUpperCase()}${value.substring(1).toLowerCase()}`;
  }
}
